import { registerElementI18nBundle } from './i18n';

registerElementI18nBundle({
    en: {
        kCpePalette: 'Color palette',
        kCpeAdd: 'Add',
        kCpeLabelPlaceholder: 'Label (e.g. Red)',
        kCpeColorCount: '{current} of {max} colors',
        kCpeNewColorLabel: 'Color {n}',
        kCpeRemove: 'Remove color',
        kFcTitleCorrect: 'Correct!',
        kFcTitleIncorrect: 'Incorrect',
        kFcTitlePartial: 'Partially Correct',
        kFcTitleHint: 'Hint',
        kFcTitleExplanation: 'Explanation',
        kTmAriaRemaining: 'Time remaining: {time}',
        kSgcRegionLabel: 'Essay grading results',
        kSgcScorePerfect: 'Perfect!',
        kSgcScoreGreat: 'Great job!',
        kSgcScoreGood: 'Good effort!',
        kSgcScorePractice: 'Keep practicing!',
        kSgcScoreRetry: 'Try again!',
        kSgcWordCount: '{n} words',
        kSgcCritContent: 'Content',
        kSgcCritForm: 'Form',
        kSgcCritGrammar: 'Grammar',
        kSgcCritVocabulary: 'Vocabulary',
        kSgcCritSpelling: 'Spelling',
        kSgcCritDsc: 'Development & Coherence',
        kSgcCritGlr: 'Language Range',
        kSgcAriaCriteriaDesc: 'Show criteria description',
        kMbLoadFailed: 'Failed to load media',
        kMbAriaPlay: 'Play',
        kMbAriaPause: 'Pause',
        kMbAriaMute: 'Mute',
        kMbAriaUnmute: 'Unmute',
        kMbAriaFullscreen: 'Fullscreen',
        kIdcEmpty: 'No image',
        kIdcAriaAddHotspot: 'Click to add hotspot',
        kRttColorDefault: 'Default',
        kRttColorText: 'Text',
        kRttColorMuted: 'Muted',
        kRttColorPrimary: 'Primary',
        kRttColorAccent: 'Accent',
        kRttColorSuccess: 'Success',
        kRttColorWarning: 'Warning',
        kRttColorError: 'Error',
        kRttColorInfo: 'Info',
        kRttHlNone: 'None',
        kRttHlYellow: 'Yellow',
        kRttHlGreen: 'Green',
        kRttHlBlue: 'Blue',
        kRttHlPink: 'Pink',
        kRttImageUrl: 'Image URL',
        kRttAudioUrl: 'Audio URL',
        kRttUrlPh: 'https://…',
        kRttInsert: 'Insert',
        kRttOr: 'or',
        kRttChooseFileMax: 'Choose file (max {maxMb}MB)',
        kRttUploading: 'Uploading…',
        kRttFileExceedsMax: 'File exceeds {maxMb}MB limit',
        kRttUploadFailed: 'Upload failed',
        kRttEmbedUrl: 'Embed URL',
        kRttEmbedHint: 'YouTube, Vimeo, or any embeddable URL',
        kRttEmbedPh: 'https://youtube.com/watch?v=…',
        kRttWidthPx: 'Width (px)',
        kRttHeightPx: 'Height (px)',
        kRttPhAuto: 'auto',
        kRttPh315: '315',
        kRttEmbedBtn: 'Embed',
        kRttLinkPromptTitle: 'Enter URL',
        kRttLinkPromptDefault: 'https://',
        kRttAriaBold: 'Bold',
        kRttAriaItalic: 'Italic',
        kRttAriaUnderline: 'Underline',
        kRttAriaStrike: 'Strikethrough',
        kRttAriaQuote: 'Blockquote',
        kRttAriaCode: 'Inline code',
        kRttAriaH1: 'Heading 1',
        kRttAriaH2: 'Heading 2',
        kRttAriaBullet: 'Bullet list',
        kRttAriaOrdered: 'Numbered list',
        kRttAriaSub: 'Subscript',
        kRttAriaSuper: 'Superscript',
        kRttAriaAlignL: 'Align left',
        kRttAriaAlignC: 'Align center',
        kRttAriaAlignR: 'Align right',
        kRttAriaAlignJ: 'Justify',
        kRttAriaClearFmt: 'Clear formatting',
        kRttAriaLink: 'Link',
        kRttAriaImage: 'Image',
        kRttAriaAudio: 'Audio',
        kRttAriaEmbed: 'Embed',
        kRttPhStyle: 'Style',
        kRttPhColor: 'Color',
        kRttStyleNormal: 'Normal',
        kRttStyleH1: 'Heading 1',
        kRttStyleH2: 'Heading 2',
        kRttStyleH3: 'Heading 3',
        kRttStyleH4: 'Heading 4',
        kRtgAriaInsertTable: 'Insert table',
        kRtgAriaCellSize: '{rows} by {cols} table',
        kRtmAddRowBefore: 'Add row before',
        kRtmAddRowAfter: 'Add row after',
        kRtmDeleteRow: 'Delete row',
        kRtmAddColBefore: 'Add column before',
        kRtmAddColAfter: 'Add column after',
        kRtmDeleteCol: 'Delete column',
        kRtmMerge: 'Merge cells',
        kRtmSplit: 'Split cell',
        kRtmToggleHeaderRow: 'Toggle header row',
        kRtmToggleHeaderCol: 'Toggle header column',
        kRtmDeleteTable: 'Delete table',
    },
    vi: {
        kCpePalette: 'Bảng màu',
        kCpeAdd: 'Thêm',
        kCpeLabelPlaceholder: 'Nhãn (ví dụ Đỏ)',
        kCpeColorCount: '{current} / {max} màu',
        kCpeNewColorLabel: 'Màu {n}',
        kCpeRemove: 'Xóa màu',
        kFcTitleCorrect: 'Chính xác!',
        kFcTitleIncorrect: 'Chưa đúng',
        kFcTitlePartial: 'Đúng một phần',
        kFcTitleHint: 'Gợi ý',
        kFcTitleExplanation: 'Giải thích',
        kTmAriaRemaining: 'Thời gian còn lại: {time}',
        kSgcRegionLabel: 'Kết quả chấm bài luận',
        kSgcScorePerfect: 'Hoàn hảo!',
        kSgcScoreGreat: 'Làm tốt lắm!',
        kSgcScoreGood: 'Cố gắng tốt!',
        kSgcScorePractice: 'Tiếp tục luyện tập!',
        kSgcScoreRetry: 'Thử lại!',
        kSgcWordCount: '{n} từ',
        kSgcCritContent: 'Nội dung',
        kSgcCritForm: 'Hình thức',
        kSgcCritGrammar: 'Ngữ pháp',
        kSgcCritVocabulary: 'Từ vựng',
        kSgcCritSpelling: 'Chính tả',
        kSgcCritDsc: 'Triển khai & mạch lạc',
        kSgcCritGlr: 'Phạm vi ngôn ngữ',
        kSgcAriaCriteriaDesc: 'Xem mô tả tiêu chí',
        kMbLoadFailed: 'Không tải được nội dung',
        kMbAriaPlay: 'Phát',
        kMbAriaPause: 'Tạm dừng',
        kMbAriaMute: 'Tắt tiếng',
        kMbAriaUnmute: 'Bật tiếng',
        kMbAriaFullscreen: 'Toàn màn hình',
        kIdcEmpty: 'Chưa có ảnh',
        kIdcAriaAddHotspot: 'Nhấn để thêm điểm nóng',
        kRttColorDefault: 'Mặc định',
        kRttColorText: 'Chữ',
        kRttColorMuted: 'Nhạt',
        kRttColorPrimary: 'Chính',
        kRttColorAccent: 'Nhấn',
        kRttColorSuccess: 'Thành công',
        kRttColorWarning: 'Cảnh báo',
        kRttColorError: 'Lỗi',
        kRttColorInfo: 'Thông tin',
        kRttHlNone: 'Không',
        kRttHlYellow: 'Vàng',
        kRttHlGreen: 'Xanh lá',
        kRttHlBlue: 'Xanh dương',
        kRttHlPink: 'Hồng',
        kRttImageUrl: 'URL ảnh',
        kRttAudioUrl: 'URL âm thanh',
        kRttUrlPh: 'https://…',
        kRttInsert: 'Chèn',
        kRttOr: 'hoặc',
        kRttChooseFileMax: 'Chọn tệp (tối đa {maxMb} MB)',
        kRttUploading: 'Đang tải lên…',
        kRttFileExceedsMax: 'Tệp vượt quá {maxMb} MB',
        kRttUploadFailed: 'Tải lên thất bại',
        kRttEmbedUrl: 'URL nhúng',
        kRttEmbedHint: 'YouTube, Vimeo hoặc URL có thể nhúng',
        kRttEmbedPh: 'https://youtube.com/watch?v=…',
        kRttWidthPx: 'Rộng (px)',
        kRttHeightPx: 'Cao (px)',
        kRttPhAuto: 'tự động',
        kRttPh315: '315',
        kRttEmbedBtn: 'Nhúng',
        kRttLinkPromptTitle: 'Nhập URL',
        kRttLinkPromptDefault: 'https://',
        kRttAriaBold: 'Đậm',
        kRttAriaItalic: 'Nghiêng',
        kRttAriaUnderline: 'Gạch chân',
        kRttAriaStrike: 'Gạch ngang',
        kRttAriaQuote: 'Trích dẫn',
        kRttAriaCode: 'Mã nội dòng',
        kRttAriaH1: 'Tiêu đề 1',
        kRttAriaH2: 'Tiêu đề 2',
        kRttAriaBullet: 'Danh sách gạch đầu dòng',
        kRttAriaOrdered: 'Danh sách đánh số',
        kRttAriaSub: 'Chỉ số dưới',
        kRttAriaSuper: 'Chỉ số trên',
        kRttAriaAlignL: 'Căn trái',
        kRttAriaAlignC: 'Căn giữa',
        kRttAriaAlignR: 'Căn phải',
        kRttAriaAlignJ: 'Căn đều',
        kRttAriaClearFmt: 'Xóa định dạng',
        kRttAriaLink: 'Liên kết',
        kRttAriaImage: 'Ảnh',
        kRttAriaAudio: 'Âm thanh',
        kRttAriaEmbed: 'Nhúng',
        kRttPhStyle: 'Kiểu',
        kRttPhColor: 'Màu chữ',
        kRttStyleNormal: 'Bình thường',
        kRttStyleH1: 'Tiêu đề 1',
        kRttStyleH2: 'Tiêu đề 2',
        kRttStyleH3: 'Tiêu đề 3',
        kRttStyleH4: 'Tiêu đề 4',
        kRtgAriaInsertTable: 'Chèn bảng',
        kRtgAriaCellSize: 'Bảng {rows} × {cols}',
        kRtmAddRowBefore: 'Thêm hàng phía trên',
        kRtmAddRowAfter: 'Thêm hàng phía dưới',
        kRtmDeleteRow: 'Xóa hàng',
        kRtmAddColBefore: 'Thêm cột bên trái',
        kRtmAddColAfter: 'Thêm cột bên phải',
        kRtmDeleteCol: 'Xóa cột',
        kRtmMerge: 'Gộp ô',
        kRtmSplit: 'Tách ô',
        kRtmToggleHeaderRow: 'Bật/tắt hàng tiêu đề',
        kRtmToggleHeaderCol: 'Bật/tắt cột tiêu đề',
        kRtmDeleteTable: 'Xóa bảng',
    },
});
